__turbopack_context__.v({
  "action": "_aSWJG_action",
  "availability": "_aSWJG_availability",
  "contactArea": "_aSWJG_contactArea",
  "headline": "_aSWJG_headline",
});
